export function isPromise(promise: Promise<any>): promise is Promise<any> {
  return typeof promise === 'object' && typeof promise?.then === 'function'
}
